import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../../../components/ui/dialog'
import { useDialogStore } from '../../../store/dialogStore'
import { useQueryClient } from '@tanstack/react-query'
import { Button } from '../../../components/ui/button'
import { useDeleteCategoryItemMutation } from '../mutations/deleteCategoryItemMutation'
import { useSharedStore } from '../../../store/sharedStore'
import { categoriesQueryKey } from '../queries/categories'
import { useToast } from '../../../components/ui/use-toast'
import { Api } from '../../../lib/axios'


export default function DeleteCategoryDialog () {
  const queryClient = useQueryClient()

  const open = useDialogStore((state) => state.open)
  const setOpen = useDialogStore((state) => state.setOpen)

  const { mutateAsync, isPending, error } = useDeleteCategoryItemMutation()
  const category = useSharedStore(state => state.selectedCategory)
  const { toast } = useToast()

  const handleDelete = async () => {
    await mutateAsync({ id: category?.id as number })
    void queryClient.invalidateQueries({ queryKey: [categoriesQueryKey] })
    toast({
      description: 'Тақырыптық санат өшірілді',
      variant: 'success',
    })
    setOpen(null)
  }

  return (
    <Dialog open={open === 'DeleteCategory'} onOpenChange={() => setOpen(null)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            Тақырыптық санатты өшіру
          </DialogTitle>
          <DialogDescription>
            Санатты жойғыңыз келетініне сенімдісіз бе? <br/>
            Кейін бұл әрекетті кері қайтара алмайсыз.
          </DialogDescription>
        </DialogHeader>

        {Api.isAxiosError(error) && (
          <span className="text-sm text-center text-destructive">
            {error?.response?.data?.responseClientMessage}
          </span>
        )}

        <div className="flex w-full gap-3 mt-3">
          <Button
            className="w-full"
            variant="secondary"
            onClick={() => setOpen(null)}
          >
            Жоқ
          </Button>
          <Button
            className="w-full"
            variant="destructive"
            loading={isPending}
            onClick={handleDelete}
          >
            Жою
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
